import React from 'react';
import {
  TextInput,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';
import PeriodInput from '../../app/periodInput.component';
import {
  leadImportFields,
  leadImportStatusChoices,
} from '../leadImports.model';
import { ORGANIZATIONS_RESOURCE_NAME as ORGANIZATIONS_RESOURCE } from '../../organizations/organizations.dataProvider';

export const leadImportFilters = [
  <TextInput
    label="Filename"
    source={leadImportFields.filename}
    alwaysOn
    size="small"
  />,
  <SelectInput
    label="Status"
    source={leadImportFields.status}
    choices={leadImportStatusChoices}
    alwaysOn
    size="small"
  />,
  <ReferenceInput
    label="Source Organization"
    source={leadImportFields.sourceOrg}
    reference={ORGANIZATIONS_RESOURCE}
    perPage={100}
    sort={{ field: 'name', order: 'ASC' }}
  >
    <AutocompleteInput 
      optionText="name" 
      size="small"
      filterToQuery={searchText => ({ name: searchText })}
      debounce={300}
    />
  </ReferenceInput>,
  <PeriodInput
    source="createdBetween"
    fromLabel="Upload Date From"
    toLabel="Upload Date To"
    label="Upload Date Range"
    size="small"
  />,
];

export default leadImportFilters;
